import { useTranslation } from 'react-i18next';
import DataTable from '../../common/components/DataTable';
import { useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../template/store';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getCustomerCodeDataList, getUserDataList, mergeMatchCodesToUser, mergeMatchCodesToUserNew } from './MappingActions';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faRedo, faSave } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useParams } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { clearMatchCodeList, selectMappingUsers } from './MappingSlice';
import { useBackNavigation } from '../../../hooks/BackNavigation';
import { toast } from 'react-toastify';


const MatchCodeList = () => {
    const { t } = useTranslation();
    const data = useSelector((state: RootState) => state.mappingDashboard.matchCodeList)
      const linerId = useSelector(
    (state: RootState) => state.userProfile.profile.partnerId
  );
    const dispatch = useDispatch<AppDispatch>()
    const {custId} = useParams()

    const onBack = useBackNavigation()

    const columnConfig = [
        //  {
        //       accessor: 'selected',
        //       Header: '',
        //       width: 50,
        //       maxWidth: 50,
        //       minWIdth: 50,
        //       Cell: (rowData: any) => {
        //         const { selected, mstUsrId } = rowData.row.original;
        //         console.log("ddd", rowData.row.original);
        //         return <Form.Check
        //         type='checkbox'
        //         checked={selected}
        //         // disabled={disabled}
        //         onChange={(e)=>{
        //                   if(mstUsrId == null){
        //                     toast.error("User ID is required to perform Merge !")
        //                   }else{
        //                     const val = e.target.checked;
        //         console.log("val1:", val,mstUsrId); // log the value
        //         dispatch(selectMappingUsers({ mstUsrId, val }));
                          
        //                   }
        //                 }}
        //         className='form-check fs-0 mb-0 d-flex align-items-center'/>
        //       }
        //     },
        {
            accessor: 'email',
            Header: t('resource_1:email'),
            width: 180,
            maxWidth: 180
        },
        {
            accessor: 'name',
            Header: 'Company Name',
            width: 180,
            maxWidth: 180
        },
        {
            accessor: 'matchCode',
            Header: 'Match Code',
            width: 180,
            maxWidth: 180,
        },
        {
            accessor: 'customerCode',
            Header: 'Customer Code',
            width: 180,
            maxWidth: 180,
        },
    ];

    return (
        <div className='col-lg-12 mt-2 mb-2 demmurageTable d-flex flex-column'>
            <Form.Label style={{color:'#E63757'}}>NOTE: Below List of users will also merge into this customer</Form.Label>
            <DataTable
                gridName='MATCHCODE'
                columns={columnConfig}
                data={data}
                shortPrepend='qp_'
                perPage={100}
                sortable={true}
                searchable={false}
                showColumnFilter={false}
                selection={false}
                pagination={false}
                seekPagination={false}
                showExport={false}
                localFilter={true}
                uniqueFilterKey='userList'
                autoHeight={true}
                maxHeight='35vh'
                tableMinHeight={300}
                staticHiddenCols={[]}
            />

            <div className='d-flex flex-row align-items-center justify-content-center'>

            <div className='d-flex justify-content-center align-items-center'>
                <Button
                    className='me-2'
                    variant='falcon-primary'
                    size='sm'
                    onClick={() => {
                        const mstPartnerId = custId
                        // dispatch(mergeMatchCodesToUser({custId:mstPartnerId})).unwrap().then(()=>{

                        dispatch(mergeMatchCodesToUserNew({custId:mstPartnerId})).unwrap().then(()=>{
                            onBack()
                            setTimeout(()=>{
                                dispatch(getUserDataList({custId:mstPartnerId}))
                                dispatch(getCustomerCodeDataList({custId:mstPartnerId,linerId:linerId}))
                            },2000)
                        }).catch(()=>{})
                    }}
                >
                    <FontAwesomeIcon icon={faSave} className='me-2' />
                    Confirm
                </Button>
            </div>

            <div className='d-flex justify-content-center align-items-center'>
                <Button
                    className='me-2'
                    variant='falcon-danger'
                    size='sm'
                    onClick={() => {
                        dispatch(clearMatchCodeList())
                    }}
                >
                    <FontAwesomeIcon icon={faRedo} className='me-2' />
                    {t('resource_1:cancel')}
                </Button>
            </div>
            </div>
        </div>
    );
};

export default MatchCodeList;
